/* @flow */
/* eslint-env es6,browser */

import { IDP_COMMONID, IDP_LIVERAMP } from './idpconstants';
import idp from './idpmanager';
import { logDebug } from '../utils/logger';

/**
 * @param {string} idprovider - IDProvider name
 * @returns {string} ID value
 */
function _getIDPId(idprovider: string = '') {
  const id = idp.getUserID(idprovider);
  logDebug(`${idprovider} value is ${id}`);
  return id;
}

/**
 *
 * @description geter for common ID
 * @returns {string} CommonID
 */
// eslint-disable-next-line import/prefer-default-export
export function getCommonID(): string {
  return _getIDPId(IDP_COMMONID);
}

/**
 * @description Helper to get LiveRamp ID
 * @returns {string} LiveRampID
 */
export function getLiveRampID(): string {
  return _getIDPId(IDP_LIVERAMP);
}
